<template>
  <el-dialog :title="titleLabel[dialogStatus] + '发票'" :visible.sync="dialogVisible" class="mx-50" top="40px">
    <table width=100%>
      <tr>
        <th width=20%>账单金额</th>
        <th width=20% >已开票金额</th>
        <!-- <th width=20% >未确认金额</th> -->
        <th width=20%>正在开票金额</th>
        <th width=20%>未开票金额</th>
        <!-- <th width=25% >不开票金额</th> -->
        <th></th>
      </tr>
      <tr>
        <td>
          总共：{{ receivable_amount }} 元<br/>
          <!-- 专票：{{ receivable_special_amount }} 元<br/>
          普票：{{ receivable_ordinary_amount }} 元<br/>
          收据：{{ no_invoice }} 元<br/> -->
        </td>
        <td>
          总共：{{ modify_confirmed_amount + no_invoice }} 元<br/>
          专票：{{ modify_confirmed_special_amount }} 元<br/>
          普票：{{ modify_confirmed_ordinary_amount }} 元<br/>
          收据：{{ no_invoice }} 元
        </td>
        <!-- <td>
          总共：{{ modify_unconfirmed_amount }} 元<br/>
          专票：{{ modify_unconfirmed_special_amount }} 元<br/>
          普票：{{ modify_unconfirmed_ordinary_amount }} 元
        </td> -->
        <td>
          总共：{{ modify_application_amount }} 元<br/>
          专票：{{ modify_application_special_amount }} 元<br/>
          普票：{{ modify_application_ordinary_amount }} 元
        </td>
        <td>
          总共：{{ modify_unapplication_amount }} 元<br/>
          专票：{{ modify_unapplication_special_amount }} 元<br/>
          普票：{{ modify_unapplication_ordinary_amount }} 元
        </td>
        <!-- <td>{{no_invoice}}</td> -->
      </tr>
    </table>
    <el-divider></el-divider>

    <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="150px" class="mx-30">
      <el-form-item prop="invoice_type" label="发票类型">
        <el-radio-group v-model="formData.invoice_type" @change="ChangeInvoiceType">
          <el-radio :label=0>专票</el-radio>
          <el-radio :label=1>普票</el-radio>
        </el-radio-group>
        <!-- <el-radio v-model="formData.invoice_type" :label=0>专票</el-radio> -->
        <!-- <el-radio v-model="formData.invoice_type" :label=1>普票</el-radio> -->
      </el-form-item>
      <el-form-item prop="invoice_maker" label="开票方" v-if="isShow">
        <el-input v-model="formData.invoice_maker" autoComplete="on"></el-input>
      </el-form-item>
      <!-- <el-form-item prop="name" label="业务单位明细">
        <el-input v-model="formData.name" autoComplete="on"></el-input>
      </el-form-item> -->
      <el-form-item prop="name" label="业务单位明细">
        <el-select v-model="formData.name" placeholder="请选择抬头" clearable value-key="id"  @change="handleSearchInvoiceTitle">
                    <el-option v-for="at in invoice_title_list" :key="at.id" :label="at.invoice_name"
                        :value="at"></el-option>
                  </el-select>
      </el-form-item>
      <!-- <el-form-item prop="name" label="业务单位类型">
          <el-input v-model="formData.type_name" autoComplete="on"></el-input>
        </el-form-item> -->
      <el-form-item prop="invoice_title_type" label="发票类型">
        <el-radio v-model="formData.invoice_title_type" :label=0>企业</el-radio>
        <el-radio v-model="formData.invoice_title_type" :label=1>个人</el-radio>
      </el-form-item>

      <el-form-item prop="name" label="统一社会信用代码">
        <el-input v-model="formData.number" autoComplete="on"  ></el-input>
      </el-form-item>

      <el-form-item label="开户银行名">
        <el-input v-model="formData.invoice_blank_name" autoComplete="on" ></el-input>
      </el-form-item>
      <el-form-item label="开户账号">
        <el-input v-model="formData.invoice_account" autoComplete="on" ></el-input>
      </el-form-item>
      <el-form-item label="注册场所地址">
        <el-input v-model="formData.invoice_address" autoComplete="on" ></el-input>
      </el-form-item>
      <el-form-item label="注册固定电话">
        <el-input v-model="formData.invoice_mobile" autoComplete="on" ></el-input>
      </el-form-item>

      <el-form-item prop="invoiced_amount" label="开票金额">
        <el-input type="number" v-model="formData.invoiced_amount" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="vat" label="税价" v-if="isShow">
        <el-input v-model="vat" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="sales" label="销售额" v-if="isShow">
        <el-input v-model="sales" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="invoice_number" label="发票号" v-if="isShow">
        <el-input type="number" v-model="formData.invoice_number" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="taxpayer_id" label="纳税人识别号" v-if="isShow">
        <el-input v-model="formData.taxpayer_id" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="invoiced_date" label="开票日期" v-if="isShow">
        <el-date-picker
          v-model="formData.invoiced_date"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="source_document" label="发票" v-if="isShow">
        <el-upload
          :data="formData"
          ref="upload"
          :headers="headers"
          action=""
          :file-list="source_document_list"
          list-type="picture"
          :limit="1"
          :on-remove="handleRemoveSourceDocument"
          :on-preview="handlePreviewSourceDocument"
          :on-change="handleChange"
          :on-exceed="handleExceed"
          :http-request="handleSubmitWithSourceDocument"
          :auto-upload="false"
        >
          <template v-if="showDialogSave">
          <el-button slot="trigger" size="small" type="success">选择发票</el-button>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item prop="remark" label="备注">
        <el-input v-model="formData.remark" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}"></el-input>
      </el-form-item>

      <el-form-item>
        <span style="float: right">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button size="small" @click="updateInvoiceTitleData">同步发票信息</el-button>
          <template v-if="showDialogSave">
          <el-button v-if="dialogStatus=='action.create'"
                     type="primary" size="small"
                     @click="saveData">保存</el-button>
          <el-button
              v-if="dialogStatus == 'action.edit' && (is_superuser ||(!is_superuser && !formData.is_superuser))"
              type="primary" size="small"
              @click="saveData">保存</el-button>
          </template>
          <el-button v-if="dialogStatus=='action.apply'"
                     type="primary" size="small"
                     @click="saveInvoice">保存</el-button>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { fetchInsuranceFinanceReceivable, createInsuranceFinanceReceivable, updateInsuranceFinanceReceivable,createInsuranceFinanceApplicationReceivable } from '@/api/group-insurance'
  import { fetchSourceDocumentList, deleteSourceDocument} from '@/api/group-insurance'
  import { getToken } from '@/utils/auth'
  import { EventBus } from "@/utils/event-bus"
  import { formatDate, formatDateTime } from '@/utils/misc'
  import { validateInvoiceNumber } from '@/utils/validate'
  import {updateInvoiceTitle} from '@/api/customer'

  export default {
    name: 'receivable-detail-dialog',
    filters: {
      formatDate
    },
    props: [
      'finance_id',
      'receivable_amount',
      'receivable_special_amount',
      'receivable_ordinary_amount',
      'confirmed_amount',
      'confirmed_special_amount',
      'confirmed_ordinary_amount',
      'unconfirmed_amount',
      'unconfirmed_special_amount',
      'unconfirmed_ordinary_amount',
      'application_amount',
      'application_special_amount',
      'application_ordinary_amount',
      'unapplication_amount',
      'unapplication_special_amount',
      'unapplication_ordinary_amount',
      'no_invoice',
    ],
    data() {
      var validateAmount = (rule, value, callback) => {
        if(
          this.modify_unconfirmed_ordinary_amount < 0.0 ||
          this.modify_unconfirmed_special_amount < 0.0 ||
          this.modify_unapplication_ordinary_amount < 0.0 ||
          this.modify_unapplication_special_amount < 0.0
        ) {
          return callback(new Error('未确认金额或未申请金额小于0'))
        } else {
          return callback()
        }
      };
      return {
        dialogStatus: null,
        dialogVisible: false,
        showDialogSave: true,
        is_superuser: undefined,
        titleLabel: {
          'action.create': '新增',
          'action.edit': '编辑',
          'action.edit': '查看',
          'action.apply': '申请'
        },
        formData: {
          invoice_maker: '',
          name: '',
          taxpayer_id: '91440101MA5APK8L9P',
          invoice_number: '',
          invoiced_amount: 0,
          invoiced_date: null,
          vat: 0,
          sales: 0,
          finance: null,
          remark: '',
          invoice_type:null,
          invoice_title_type:'',
        },
        isDisabled: false,
        isShow: true,
        account_sum:0,
        initAmount: 0.0,
        initInvoiceType: null,
        source_document_list:[],
        invoice_title_list: [],
        rules: {
          invoice_type: [
            {required: true, message:'请选择发票类型' ,trigger: 'blur'},
          ],
          name: [
            {required: true, message:'请填写业务单位明细' ,trigger: 'blur'},
          ],
          invoiced_amount: [
            {required: true, message:'请输入开票金额' ,trigger: 'blur'},
            {validator: validateAmount, trigger: 'blur'}
          ],
          invoiced_date: [
            {required: true, message:'请选择到账日期' ,trigger: 'blur'},
          ],
          invoice_number: [
            {required: true, trigger: 'blur', validator: validateInvoiceNumber},
          ],
          // taxpayer_id: [
          //   {required: true, message:'请输入纳税人识别号' ,trigger: 'blur'},
          // ],
        }
      }
    },
    computed: {
      modify_confirmed_amount: function(){
        let result = 0.0
        result = this.modify_confirmed_special_amount + this.modify_confirmed_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      modify_confirmed_special_amount: function(){
        if (this.formData.invoice_type === null ||
        this.formData.invoice_type === undefined ||
        this.formData.invoice_type === '' ||
        this.formData.invoiced_amount === null ||
        this.formData.invoiced_amount === undefined ||
        this.formData.invoiced_amount === '' ||
        this.dialogStatus === 'action.apply') {
          return this.confirmed_special_amount
        }
        let result = 0.0
        if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
          // 如果修改了发票类型
          if (this.formData.invoice_type === 0) {
            // 由普票修改为专票，已确认专票金额应加上原金额
            result = this.confirmed_special_amount + this.initAmount
          } else {
            // 由专票修改为普票，已确认专票金额应减去原金额
            result = this.confirmed_special_amount - this.initAmount
          }
        } else {
          if (this.formData.invoice_type === 0) {
            result = this.confirmed_special_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
          } else {
            return this.confirmed_special_amount
          }
        }
        return parseFloat(result.toFixed(4))
      },
      modify_confirmed_ordinary_amount: function(){
        if (this.formData.invoice_type === null ||
        this.formData.invoice_type === undefined ||
        this.formData.invoice_type === '' ||
        this.formData.invoiced_amount === null ||
        this.formData.invoiced_amount === undefined ||
        this.formData.invoiced_amount === '' ||
        this.dialogStatus === 'action.apply') {
          return this.confirmed_ordinary_amount
        }
        let result = 0.0
        if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
          // 如果修改了发票类型
          if (this.formData.invoice_type === 0) {
            // 由普票修改为专票，已确认普票金额应减去原金额
            result = this.confirmed_ordinary_amount - this.initAmount
          } else {
            // 由专票修改为普票，已确认普票金额应加上原金额
            result = this.confirmed_ordinary_amount + this.initAmount
          }
        } else {
          if (this.formData.invoice_type === 1) {
            result = this.confirmed_ordinary_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
          } else {
            return this.confirmed_ordinary_amount
          }
        }
        return parseFloat(result.toFixed(4))
      },
      modify_application_amount: function(){
        let result = 0.0
        result = this.modify_application_special_amount + this.modify_application_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      modify_application_special_amount: function(){
        if (this.formData.invoice_type === null ||
        this.formData.invoice_type === undefined ||
        this.formData.invoice_type === '' ||
        this.formData.invoiced_amount === null ||
        this.formData.invoiced_amount === undefined ||
        this.formData.invoiced_amount === '' ||
        this.dialogStatus !== 'action.apply') {
          return this.application_special_amount
        }
        let result = 0.0
        if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
          // 如果修改了发票类型
          if (this.formData.invoice_type === 0) {
            // 由普票修改为专票，已确认专票金额应加上原金额
            result = this.application_special_amount + this.initAmount
          } else {
            // 由专票修改为普票，已确认专票金额应减去原金额
            result = this.application_special_amount - this.initAmount
          }
        } else {
          if (this.formData.invoice_type === 0) {
            result = this.application_special_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
          } else {
            return this.application_special_amount
          }
        }
        return parseFloat(result.toFixed(4))
      },
      modify_application_ordinary_amount: function(){
        if (this.formData.invoice_type === null ||
        this.formData.invoice_type === undefined ||
        this.formData.invoice_type === '' ||
        this.formData.invoiced_amount === null ||
        this.formData.invoiced_amount === undefined ||
        this.formData.invoiced_amount === '' ||
        this.dialogStatus !== 'action.apply') {
          return this.application_ordinary_amount
        }
        let result = 0.0
        if (this.initInvoiceType !== null && this.formData.invoice_type !== this.initInvoiceType) {
          // 如果修改了发票类型
          if (this.formData.invoice_type === 0) {
            // 由普票修改为专票，已确认普票金额应减去原金额
            result = this.application_ordinary_amount - this.initAmount
          } else {
            // 由专票修改为普票，已确认普票金额应加上原金额
            result = this.application_ordinary_amount + this.initAmount
          }
        } else {
          if (this.formData.invoice_type === 1) {
            result = this.application_ordinary_amount + parseFloat(this.formData.invoiced_amount) - this.initAmount
          } else {
            return this.application_ordinary_amount
          }
        }
        return parseFloat(result.toFixed(4))
      },
      modify_unconfirmed_amount: function(){
        let result = 0.0
        result = this.modify_unconfirmed_special_amount + this.modify_unconfirmed_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      modify_unconfirmed_special_amount: function(){
        let result = 0.0
        result = this.receivable_special_amount - this.modify_confirmed_special_amount
        return parseFloat(result.toFixed(4))
      },
      modify_unconfirmed_ordinary_amount: function(){
        let result = 0.0
        result = this.receivable_ordinary_amount - this.modify_confirmed_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      modify_unapplication_amount: function(){
        let result = 0.0
        result = this.modify_unapplication_special_amount + this.modify_unapplication_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      modify_unapplication_special_amount: function(){
        let result = 0.0
        result = this.modify_unconfirmed_special_amount - this.modify_application_special_amount
        return parseFloat(result.toFixed(4))
      },
      modify_unapplication_ordinary_amount: function(){
        let result = 0.0
        result = this.modify_unconfirmed_ordinary_amount - this.modify_application_ordinary_amount
        return parseFloat(result.toFixed(4))
      },
      headers() {
        return {'Authorization': 'Token ' + getToken()}
      },
      vat: function () {
        let tempAmount = 0.0
        if (this.formData.invoiced_amount !== null && this.formData.invoiced_amount !== undefined && this.formData.invoiced_amount !== '') {tempAmount = this.formData.invoiced_amount}
        let result = (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06)
        return result.toFixed(4)
      },
      sales: function() {
        let tempAmount = 0.0
        if (this.formData.invoiced_amount !== null && this.formData.invoiced_amount !== undefined && this.formData.invoiced_amount !== '') {tempAmount = this.formData.invoiced_amount}
        let result = (parseFloat(tempAmount) - (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06))
        return result.toFixed(4)
      },
    },
    methods: {
      ChangeInvoiceType(val) {
        this.formData.invoiced_amount = 0
        if (val === 0) {
          this.formData.invoiced_amount = this.modify_unapplication_special_amount
        }
        else if (val === 1) {
          this.formData.invoiced_amount = this.modify_unapplication_ordinary_amount
        }
      },
      updateInvoiceTitleData(){
        let invoice_title = {}
        invoice_title.id = this.select_invoice_title
        invoice_title.invoice_name = this.formData.name
        invoice_title.invoice_type = Number(this.formData.invoice_title_type)
        invoice_title.invoice_blank_name = this.formData.invoice_blank_name
        invoice_title.invoice_account = this.formData.invoice_account
        invoice_title.invoice_address = this.formData.invoice_address
        invoice_title.invoice_mobile = this.formData.invoice_mobile
        invoice_title.invoice_number = this.formData.number
        console.log(invoice_title)
        updateInvoiceTitle(invoice_title)
        .then(res => {
          this.$message.success('同步成功！')
        })
        .catch(err => {
          this.$error_message(err)
        })
      },
      saveInvoice(){
        let fd = new FormData()
        this.formData.finance = this.finance_id

        fd.set('name', this.formData.name)
        fd.set('invoice_title_type',this.formData.invoice_title_type)
        fd.set('invoiced_amount', this.formData.invoiced_amount)
        fd.set('finance', parseInt(this.formData.finance))
        fd.set('remark', this.formData.remark)
        fd.set('invoice_type', this.formData.invoice_type)     
        fd.set('number',this.formData.number)
        fd.set('invoice_blank_name',this.formData.invoice_blank_name)
        fd.set('invoice_account',this.formData.invoice_account)
        fd.set('invoice_address',this.formData.invoice_address)
        fd.set('invoice_mobile',this.formData.invoice_mobile)
        fd.set('member_id',this.customer)
        console.log(parseFloat(this.modify_unconfirmed_amount),parseFloat(this.formData.invoiced_amount))
        if (this.dialogStatus === 'action.apply') {
          // if(parseFloat(this.modify_unconfirmed_amount) < parseFloat(this.formData.invoiced_amount)) {
          //   this.$message.error("申请金额不能大于可开票金额");
          //   return
          // }
          // if ((parseFloat(this.account_sum) + parseFloat(this.formData.invoiced_amount)) > (parseFloat(this.receivable_amount) - parseFloat(this.no_invoice))){
          //   this.$message.error("当前申请中和已通过的申请金额已经大于可开票金额，请核对！");
          //   return
          // }
          this.$refs['dataForm'].validate(valid => {
          if (valid) {
          createInsuranceFinanceApplicationReceivable(fd)
          .then(res => {
            this.$message.success(`申请开票成功, id=${res.id}`)
            this.$nextTick(() => {
              this.dialogVisible = false
              this.resetFormData()
              this.$refs['dataForm'].clearValidate()
              this.$emit('updateList')
            })
          })
          .catch(error => {
            this.$error_message(error)
          })
          }})
        } else {
          this.$error_message('无效的操作')
        }
      },
      resetFormData() {
        this.formData = {
          name: '',
          taxpayer_id: '91440101MA5APK8L9P',
          invoice_number: '',
          invoiced_amount: 0,
          invoiced_date: null,
          finance: null,
          remark: '',
          invoice_type:null,
        }
        this.isDisabled = false,
        this.initAmount = 0.0
        this.initInvoiceType = null
      },
      handleCreate(invoice_maker, name,invoice_title_list) {
        this.dialogStatus = 'action.create'
        this.dialogVisible = true
        this.isShow = true
        this.invoice_title_list = invoice_title_list
        this.is_superuser = this.$store.getters.is_superuser
        this.source_document_list = []
        this.resetFormData()
        this.$set(this.formData, 'invoice_maker', invoice_maker)
        // this.$set(this.formData, 'name', name)
        if (invoice_title_list.length !== 0){
          this.$set(this.formData, 'name', invoice_title_list[0].invoice_name)
          this.$set(this.formData, 'number', invoice_title_list[0].invoice_number)
          this.$set(this.formData, 'invoice_title_type', Number(invoice_title_list[0].invoice_type))
          this.$set(this.formData, 'invoice_blank_name', invoice_title_list[0].invoice_blank_name)
          this.$set(this.formData, 'invoice_account', invoice_title_list[0].invoice_account)
          this.$set(this.formData, 'invoice_address', invoice_title_list[0].invoice_address)
          this.$set(this.formData, 'invoice_mobile', invoice_title_list[0].invoice_mobile)
        }
      },
      handleUpdate(id, showDialogSave) {
        this.showDialogSave = showDialogSave
        this.dialogStatus = 'action.edit'
        this.isShow = true
        let login_userid = this.$store.state.user.user
        this.id = id
        this.resetFormData()

        fetchInsuranceFinanceReceivable(this.id)
          .then(res => {
            this.formData = Object.assign({}, res)
            this.is_owner = (login_userid == id)
            this.dialogVisible = true
            this.isDisabled = true
            this.initInvoiceType = this.formData.invoice_type
            this.initAmount = this.formData.invoiced_amount
            this.handleGetSourceDocumentList(this.id)
            this.formData.invoice_title_type = Number(res.invoice_title_type)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      handleView(id, showDialogSave) {
        this.showDialogSave = showDialogSave
        this.dialogStatus = 'action.view'
        let login_userid = this.$store.state.user.user
        this.id = id
        this.isShow = true
        this.resetFormData()

        fetchInsuranceFinanceReceivable(this.id)
          .then(res => {
            this.formData = Object.assign({}, res)
            this.is_owner = (login_userid == id)
            this.dialogVisible = true
            this.isDisabled = true
            this.initInvoiceType = this.formData.invoice_type
            this.initAmount = this.formData.invoiced_amount
            this.handleGetSourceDocumentList(this.id)
            this.formData.invoice_title_type = Number(res.invoice_title_type)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      handleSearchInvoiceTitle(value){
        if(value){
          this.$set(this.formData, 'name', value.invoice_name)
          this.$set(this.formData, 'number', value.invoice_number)
          this.$set(this.formData, 'invoice_title_type', Number(value.invoice_type))
          this.$set(this.formData, 'invoice_blank_name', value.invoice_blank_name)
          this.$set(this.formData, 'invoice_account', value.invoice_account)
          this.$set(this.formData, 'invoice_address', value.invoice_address)
          this.$set(this.formData, 'invoice_mobile', value.invoice_mobile)
          this.select_invoice_title = value.id
        }

      },
      handleApply(invoice_title_list,customer,insurance_finance_receivable_application_list) {
        let account_sum = 0
        insurance_finance_receivable_application_list.forEach(item => {       
          if (item.status_name === "待审核" || item.status_name === "通过") {
            account_sum = account_sum + item.invoiced_amount
          }
        })
        this.account_sum = account_sum
        this.invoice_title_list = invoice_title_list
        if (this.invoice_title_list.length > 0){
          this.select_invoice_title = invoice_title_list[0].id
        }
        else {        
            this.$error_message('请先维护该客户的发票信息,可通过左上角开票信息管理直接跳转到客户界面！')
            return
        }

        
        this.dialogStatus = 'action.apply'
        this.dialogVisible = true
        this.isShow = false
        this.customer = customer
        if (invoice_title_list.length !== 0){
          this.$set(this.formData, 'name', invoice_title_list[0].invoice_name)
          this.$set(this.formData, 'number', invoice_title_list[0].invoice_number)
          this.$set(this.formData, 'invoice_title_type', Number(invoice_title_list[0].invoice_type))
          this.$set(this.formData, 'invoice_blank_name', invoice_title_list[0].invoice_blank_name)
          this.$set(this.formData, 'invoice_account', invoice_title_list[0].invoice_account)
          this.$set(this.formData, 'invoice_address', invoice_title_list[0].invoice_address)
          this.$set(this.formData, 'invoice_mobile', invoice_title_list[0].invoice_mobile)
        }
      },
      cancelData() {
        this.resetFormData()
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
        this.dialogVisible = false
      },
      handleGetSourceDocumentList(invoiceID) {
        fetchSourceDocumentList(invoiceID, 'insurancefinancereceivable')
          .then( resp=>{
            this.source_document_list = resp
          }).catch( err=>{
            this.$error_message(err)
          })
      },
      handlePreviewSourceDocument(file) {
        window.open(file.url, "_blank")
      },
      handleRemoveSourceDocument(file, fileList) {
        this.source_document_list = fileList
        if (this.showDialogSave) {
          deleteSourceDocument(file.id)
            .then( resp=>{
              this.$message.success('发票已被删除')
            }).catch( err=>{
              this.$error_message(err)
            })
        }
      },
      handleChange(file, fileList) {
        this.source_document_list = fileList
      },
      handleExceed() {
        this.$message({ type:'warning', message:'只能上传1张发票'})
      },
      needSubmitWithSourceDocument() {
        // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
        let needUpload = false
        if (this.$refs.upload.uploadFiles.length > 0){
          for (let f of this.$refs.upload.uploadFiles){
            if ('raw' in f) {
              needUpload = true
              break
            }
          }
          return needUpload
        }
      },
      handleSubmitWithSourceDocument(param) {
        let fd = new FormData()
        this.formData.finance = this.finance_id

        fd.set('name', this.formData.name)
        fd.set('invoice_maker', this.formData.invoice_maker)
        fd.set('taxpayer_id', this.formData.taxpayer_id)
        fd.set('invoice_number', this.formData.invoice_number)
        fd.set('invoiced_amount', this.formData.invoiced_amount)
        fd.set('vat', this.vat)
        fd.set('sales', this.sales)
        fd.set('finance', parseInt(this.formData.finance))
        fd.set('remark', this.formData.remark)
        fd.set('invoice_type', this.formData.invoice_type)
        fd.set('invoice_title_type',this.formData.invoice_title_type)
        fd.set('number',this.formData.number)
        fd.set('invoice_blank_name',this.formData.invoice_blank_name)
        fd.set('invoice_account',this.formData.invoice_account)
        fd.set('invoice_address',this.formData.invoice_address)
        fd.set('invoice_mobile',this.formData.invoice_mobile)

        let oldDate = new Date(this.formData.invoiced_date).getTime()
        let newDate = new Date(oldDate)
        fd.set('invoiced_date', formatDateTime(newDate))

        if (param !== null){
          let fileObj = param.file
          fd.append('file', fileObj)
        }
        if (this.dialogStatus === 'action.create') {
          createInsuranceFinanceReceivable(fd)
          .then(res => {
            this.$message.success(`新增收入成功, id=${res.id}`)
            this.$nextTick(() => {
              this.dialogVisible = false
              this.resetFormData()
              // this.$refs['dataForm'].clearValidate()
              this.$emit('updateList')
            })
          })
          .catch(error => {
            this.$error_message(error)
          })
        } else if (this.dialogStatus === 'action.edit') {
          updateInsuranceFinanceReceivable(this.id, fd)
          .then(() => {
            this.$message.success('修改收入信息成功')
            this.$refs.dataForm.resetFields()
            this.dialogVisible = false
            this.$emit('updateList')
          })
          .catch(error => {
            this.$error_message(error)
          })
        } else {
          this.$error_message('无效的操作')
        }
      },
      saveData(){
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            if (this.needSubmitWithSourceDocument()) {
              this.$refs.upload.submit()
            } else {
              this.handleSubmitWithSourceDocument(null)
            }
          }
        })
      }
    },
    created() {
      this.formData.finance = this.finance_id
    }
  }
</script>
